import { ID, Response } from '../../../../../../_metronic/helpers'

type memoryMaker = {
  [key: string]: any;
};

type printerDevice = {
  enabled: boolean
  label: string
}

type printerAssignments = {
  memoryMakerToDevice?: Record<string, string>
}

export type Event = {
  id?: string
  name?: string
  avatar?: any
  dateCreated?: string
  updatedOn?: string
  startDate?: any
  endDate?: any
  parent?: any
  clients?: any
  associatedCollections?: any
  apiType?: string
  apiEnhance?: boolean
  testingMode?: boolean
  apiVersion?: string
  templates?: Array<string>
  frames?: Array<string>
  initialToolFrame?: boolean
  memoryMakers?: memoryMaker[]
  printerDevices?: any
  defaultPrinterDeviceId?: string
  printerAssignments?: printerAssignments
  projectNo?: string
  qrCards?: boolean
  isIntro?: boolean
  intro?: string
  isForm?: boolean
  form?: string
  isMail?: boolean//sendMicrositeLink2
  sendgrid?: string//sendMicrositeLink2
  wixMail?: string//sendMicrositeLink2
  qrMail?: string
  mailParagraph?: string//send in mail
  isDooh?: boolean
  autoPrint?: boolean
  isPrintDefault?: boolean
  printableTemplateId?: string
  dooh?: string
  mailParagraphDooh?: string
  sendgridDooh?: string
  quitclaim?: string
  isMicrositeDefault?: boolean
  isMicrosite?: boolean//sendMicrositeLink2
  microsite?: string//wix router - send in mail
  router?: string//wix router - send in mail
  isRouter?: boolean
  micrositeBeta?: string//wix router
  micrositeDate?: any//send in mail
  micrositeName?: string//send in mail
  exportFolder?: string//lucy
  isAnalytics?: boolean
  embedCode?: string
  info?: string
  tags?: Array<string>
  mailType?: string
  zearch?: Array<string>
}

export type EventsQueryResponse = Response<Array<Event>>

export const initialEvent: Event = {
  avatar: '',
  name: '',
  router: '',
  mailParagraph: '',
  printableTemplateId: '',
  initialToolFrame: false,
  autoPrint: false,
  printerDevices: [],
  defaultPrinterDeviceId: '',
  printerAssignments: {
    memoryMakerToDevice: {},
  },
  info: '',
  endDate: ''
}
